export default __webpack_public_path__ + "static/ubc_vancouver_spring_2021_convocation_program-a655d61385cb65f9625df04dcd9ee48d.pdf";